import Vue from 'vue'
import Vuex from 'vuex'
import addrouters from './modules/addrouters'
import login from './modules/login'
import cache from './modules/cache'

import { getDictArray } from '@/utils/sysDict'
import { getCommData } from '@/Api/commercial'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    addrouters,
    login,
    cache
  },
  state: {
    // cacheKeys: {},
    // dict_orderSource: [], // 订单来源  keyId : orderSource
    // dict_commId: [], // 所属商户  keyId : commId
    // dict_whiteCardOrderSource: [], // 离线订单字典   keyId : whiteCardOrderSource
    // dict_orderStatus: [], // 订单状态
    // dict_orderStartType: [], //启动方式
    // dict_payChannel: [], // 支付类型
    dict_appoint: [], // 新增站点是否需要预约
    // dict_payMod: [], // 新增站点-支付方式
    dict_scope: [], // 新增站点-使用范围
    // dict_userParams: [], // 客户列表-查询方式
    // dict_source: [], // 客户列表-客户来源渠道
    // dict_sourceId: [], // 客户渠道
    // dict_transType: [], // 充值查询条件：增加，减少
    // dict_gunType: [], // 枪头监控类型： 直流，交流
    dict_siteType: [] // 站点类型
    // dict_warStatus: [], // 查询告警状态
    // dict_orderAbnormalStatus: [], // 异常订单支付状态
    // dict_currentType: [], // 充电桩类型
    // dict_orderAbnormalReason: [], //异常原因
    // dict_orderSettlementType: [], //结算类型细分
    // dict_orderPayAccountType: [], //结算账户类型
    // dict_payType: [], //订单-支付方式
    // dict_flowType: [], //充值类型
    // dict_flowOutAccountType: [], //充值-支付方式
    // dict_taxType: [], //开票类型
    // dict_flowInAccountType: [], //到账账户
    // dict_expressStatus: [], //寄送状态
    // dict_sourceType: [], //充值来源
  },
  getters: {
    // 获取字典或者查询条件通用数据
    getDict(state) {
      console.info('state', state)
      return async function(keyId) {
        // keyId 是要获取的数据类型，与state中匹配
        const name = `dict_${keyId}`
        let res = []
        if (keyId == 'commId') {
          // 归属商户查询
          try {
            const result = (await getCommData()).data
            res = result.youngers
            // console.log('res.data.id', result.id);

            localStorage.setItem('commId', result.id)
            state[name] = res
          } catch (err) {
            console.log(err)
          }
        } else if (state[name].length > 0) {
          // console.log(`${keyId} ^_^有了`);
          res = state[`dict_${keyId}`]
        } else {
          // 执行字典查询
          // console.log(`${keyId} 字典接口访问`);
          try {
            res = await getDictArray('', keyId)
            state[name] = res
          } catch (err) {
            console.log(err)
          }
        }
        return res
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js